import React from "react"
import styled, { withTheme } from "styled-components"

const ChatIconWrapper = styled.div`
  display: flex;
  left: 0;
  width: 24px;
  height: 24px;
  margin: 0 0 4px;
`

let BuoyChatIcon = ({ theme }) => (
  <svg width="100%" height="100%" x="0px" y="0px" viewBox="0 0 32 32">
    <g>
      <path
        fill={theme.colors.primary}
        d="M16,32H0l0-16C0,7.2,7.2,0,16,0h0c8.8,0,16,7.2,16,16v0C32,24.8,24.8,32,16,32z"
      />
      <path
        fill="white"
        d="M21.6,18.5c0-3.1-2.5-5.6-5.6-5.6c-1,0-2,0.3-2.8,0.8l0-5.3c0-0.9-0.6-1.6-1.4-1.6h0h0h-1.4c0,0,0,11.7,0,11.7
          c0,3.1,2.5,5.6,5.6,5.6C19,24.1,21.6,21.6,21.6,18.5z M18.8,18.5c0,1.6-1.3,2.8-2.8,2.8s-2.8-1.3-2.8-2.8s1.3-2.8,2.8-2.8
          S18.8,16.9,18.8,18.5z"
      />
    </g>
  </svg>
)

BuoyChatIcon = withTheme(BuoyChatIcon)

const WrappedBuoyChatIcon = props => (
  <ChatIconWrapper {...props} id={props.id}>
    <BuoyChatIcon />
  </ChatIconWrapper>
)

export { WrappedBuoyChatIcon as default, ChatIconWrapper }



// WEBPACK FOOTER //
// ./assets/interview/components/BuoyChatIcon.js